module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-9a15cc4a.png";